import React from 'react';
import './InstinctiveLabs.css';
import foxLogo from '../assets/green_mint-logo-transparent-bg.png';
import bannerBg from '../assets/instinctive-labs-banner.svg';

function InstinctiveLabs() {
  return (
    <section id="instinctive-labs" className="instinctive-labs" style={{ backgroundImage: `url(${bannerBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <div className="section-container">
        <div className="il-banner">
          <div className="il-logo-area">
            <img src={foxLogo} alt="Instinctive Labs" className="il-fox-logo" />
          </div>

          <div className="il-content">
            <div className="il-header">
              <h3 className="il-name">Instinctive Labs</h3>
              <span className="il-badge">AI R&D Studio</span>
            </div>
            <p className="il-tagline">Trust the signal.</p>
            <p className="il-description">
              Building AI systems at the intersection of human instinct and machine intelligence.
              Autonomous agents, infrastructure, and applied research that ships.
            </p>
            <div className="il-links">
              <a
                href="https://x.com/instinctivelabs"
                target="_blank"
                rel="noopener noreferrer"
                className="il-social-link"
              >
                <span className="il-social-icon">𝕏</span>
              </a>
              <a
                href="https://www.linkedin.com/company/instinctivelabs"
                target="_blank"
                rel="noopener noreferrer"
                className="il-social-link"
              >
                <span className="il-social-icon">in</span>
              </a>
              <a
                href="https://instagram.com/instinctivelabs"
                target="_blank"
                rel="noopener noreferrer"
                className="il-social-link"
              >
                <i className="fab fa-instagram il-social-icon"></i>
              </a>
              <a
                href="https://x.com/instinctivelabs"
                target="_blank"
                rel="noopener noreferrer"
                className="il-cta"
              >
                Follow our journey →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default InstinctiveLabs;
